const initShareButtons = (): void => {
  const shareButtons = document.querySelectorAll<HTMLAnchorElement>(
    '[data-share]',
  );
  for (let i = 0; i < shareButtons.length; i += 1) {
    const button = shareButtons[i];
    button.onclick = (e) => {
      e.preventDefault();
      window.open(button.href, '_blank', 'height=480,width=480');
    };
  }
};

// eslint-disable-next-line import/prefer-default-export
export { initShareButtons };
